import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column, ColumnProps } from "primereact/column";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";

interface ReusableDataTableProps {
  data: any[];
  columns: ColumnProps[];
  onFetchData: (page: number, rows: number, filter?:Record<string, any> ) => void;
  globalFilterFields?: string[];
  header?: React.ReactNode;
  emptyMessage?: string;
  selection?: any;
  onSelectionChange?: (e: any) => void;
  selectionMode?: null | "multiple" | "checkbox";
  paginatorTemplate?: string;
  currentPageReportTemplate?: string;
  rowsPerPageOptions?: number[];
  ref?: any;
  filters?: Record<string, any>;
  pagination: { page: number; rows: number; totalRecords: number };
  onRowDoubleClick?: (data: any) => void; // <-- NEW
  setPagination: React.Dispatch<
    React.SetStateAction<{ page: number; rows: number; totalRecords: number }>
  >;
  setFilters?: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const ReusableDataTable: React.FC<ReusableDataTableProps> = ({
  data,
  columns,
  onFetchData,
  globalFilterFields,
  header,
  emptyMessage = "No data found.",
  selection,
  onSelectionChange,
  selectionMode = "multiple",
  paginatorTemplate = "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  rowsPerPageOptions = [ 25, 50, 100, 200],
  ref,
  filters,
  pagination,
  onRowDoubleClick,
  setPagination,
  setFilters
}) => {
  console.log("records:", pagination);
  const loading = useSelector((state: RootState) => state.common.data.loading); 
  console.log("Filter:", filters);

  // State for filters
  const [tableFilters, setTableFilters] = useState<Record<string, any>>(
    () => filters ?? {}
  );
  
  // const [tableFilters, setTableFilters] = useState<Record<string, any>>(filters );

  const onPageChange = (e: any) => {
    const { page, rows } = e;
    console.log("records:", pagination);
  
    setPagination((prev) => {
      const newPage = page + 1; // Adjust for PrimeReact 0-based index
      const updatedPagination = { ...prev, page: newPage, rows };
      return updatedPagination;
    });
  
    onFetchData(page + 1, rows, filters);

  };  
  

  useEffect(() => {
    onFetchData(pagination.page, pagination.rows, filters);
  }, []);

    // Handle filter change
    const onFilter = (event: any) => {
      console.log(event.filters,'event.filters');
      setFilters && setFilters(event.filters);
      setTableFilters(event.filters);
      onFetchData(pagination.page, pagination.rows, event.filters);
      console.log("records:", pagination);
      // setPagination((prev) => ({ ...prev, page: 1 })); // Reset to first page on filter change
    };

    const from = (pagination.page - 1) * pagination.rows + 1;
    const to = Math.min(from + pagination.rows - 1, pagination.totalRecords);

    const currentPageReportTemplate = `Showing ${from} to ${to} of ${pagination.totalRecords} records`;

  return (
    <Box>
      <DataTable
        sortMode="multiple"
        ref={ref}
        value={data}
        paginator
        lazy
        filters={tableFilters}
        onFilter={onFilter}
        //first={pagination.page} // Adjusts first record index dynamically
        loading={loading}
        first={(pagination.page - 1) * pagination.rows}
        rows={pagination.rows}
        onPage={onPageChange}
        header={header}
        emptyMessage={emptyMessage}
        selection={selection}
        onSelectionChange={onSelectionChange}
        paginatorTemplate={paginatorTemplate}
        currentPageReportTemplate={`Showing ${(pagination.page - 1) * pagination.rows + 1} to ${Math.min(pagination.page * pagination.rows, pagination.totalRecords)} of ${pagination.totalRecords} records`}
        rowsPerPageOptions={rowsPerPageOptions}
        globalFilterFields={globalFilterFields}
        tableStyle={{ minWidth: "50rem" }}
        // filters={filters}
        scrollable
        scrollHeight="700px"
        selectionMode={selectionMode}
        totalRecords={pagination.totalRecords}
        onRowDoubleClick={(e) => {
            if (onRowDoubleClick) onRowDoubleClick(e.data);
          }}
        > 
      
        {columns.map((col, i) => (
          <Column key={i} {...col} />
        ))}
      </DataTable>
    </Box>
  );
};

export default ReusableDataTable;


